var viewerScriptFlowAPI;
var viewerScriptFlowAPIInitPromise;
var appData = {};
export var getViewerScriptFlowAPI = function () {
    return viewerScriptFlowAPI;
};
export var setViewerScriptFlowAPI = function (newViewerScriptFlowAPI) {
    viewerScriptFlowAPI = newViewerScriptFlowAPI;
};
export var getViewerScriptFlowAPIInitPromise = function () {
    return viewerScriptFlowAPIInitPromise;
};
export var setViewerScriptFlowAPIInitPromise = function (newViewerScriptFlowAPIInitPromise) {
    viewerScriptFlowAPIInitPromise = newViewerScriptFlowAPIInitPromise;
};
export var getAppData = function () {
    return appData;
};
export var setAppData = function (newAppData) {
    appData = newAppData;
};
//# sourceMappingURL=sharableInstances.js.map